import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Form, Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function AjustesInventarioCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AJUSTES_INVENTARIO = process.env.REACT_APP_URL_AJUSTES_INVENTARIO;
  const URL_ARTICULOS_AJUSTES_INV =
    process.env.REACT_APP_URL_ARTICULOS_AJUSTES_INV;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [inventarios, setInventarios] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [total, setTotal] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const classes = useStyles();
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      cantInv: 0,
      idInv: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveAjustesInventario = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    let totalMails = inputFields.length
    try {
      await axios
        .post(
          URL_AJUSTES_INVENTARIO,
          {
            fecha,
            areas: selectedArea,
            observaciones,
            user: user.id,
            total,
            autorizado: "No",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            axios.post(
              URL_ARTICULOS_AJUSTES_INV,
              {
                ajustesInventario: data.data._id,
                articulos: a.articulos,
                cantidad: parseFloat(a.cantidad),
                inventarios: a.idInv,
                areas: selectedArea,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(()=>{
              
          axios.post(
            URL_LOGS,
            {
              tipo: "Crear Ajuste Inventario",
              detalle: `Area: ${selectedArea} Articulo:${a.articulos} Cantidad: ${a.cantidad}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
          totalMails = totalMails - 1
          if(totalMails == 0){
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          }).catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        })

            }) .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        })
          })

        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
          i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    if (
      inputFields.filter((e) => e.articulos == selectedArticulo.idArticulo).length > 0
    ) {
      inventarios.map((a) => {
        if (a.idArticulo == selectedArticulo._id) {
          let idArticulo = selectedArticulo._id;
          // let cantInv = parseFloat(a.cantidad);
          // let idInv = a._id;
          let costoUnitario = a.costoUnitario
          handleChangeInputArticuloUnico(id, idArticulo, costoUnitario);
        }
      });
    } else {
      // inventarios.map((a) => {
        // if (a.idArticulo == event.target.value) {
        //   let idArticulo = a.idArticulo;
          handleChangeInputArticulo(id, selectedArticulo._id);
      //   }
      // });
    }
  }
 
  const handleChangeInputArticuloUnico = (id, idArticulo, costoUnitario) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = 0;
        // i.idInv = idInv;
        i.costoUnitario = costoUnitario
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = 0
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaUbicacion(id, idInventario) {
    if (inputFields.filter((e) => e.idInv == idInventario).length > 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo en esa Ubicacion ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.cantInv = 0;
          i.idInv = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    } else {
      inventarios.map((a) => {
        if (a._id == idInventario) {
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          handleChangeInputArticuloUbicacion(id, cantInv, idInv);
        }
      });
    }
  }

  const handleChangeInputArticuloUbicacion = (id, cantInv, idInv) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantInv = parseFloat(cantInv);
        i.idInv = idInv;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  }

  function jalaAlmacen(e) {
    setSelectedArea(e);

    axios
      .get(`${URL_INVENTARIOS}/traspasos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);

        let result = allInventarios.map((a) => a.idArticulo);
        setIdsArticulos(result);

        let unicos = allInventarios.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArticulo === value.idArticulo)
        );
        setArticulosUnicos(unicos);
      })
      .catch((err) => {
        console.log(err);
      });

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
      },
    ]);
  }

  function BuscaCodigo(id, event) {
    if (event.target.value.length >= 24) {
      if (idsArticulos.includes(event.target.value)) {
        inventarios.map((a) => {
          if (a.idArticulo == event.target.value) {
            let idArticulo = a.idArticulo;
            handleChangeInputArticulo(id, idArticulo);
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El modelo no aparece en tu inventario",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.articulos = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const options = articulos.map((option) => {
    const junta = option.SKU + option.nombre;
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

    function importarArchivo(event){
   const target = event.target;
   const value = target.type === "checkbox" ? target.checked : target.value;
   const name = target.name;
   let hojas = [];
  
   if (name === "file") {
 
     let reader = new FileReader();
       reader.readAsArrayBuffer(target.files[0]);
       reader.onloadend = (e) => {
         var data = new Uint8Array(e.target.result);
         var workbook = XLSX.read(data, { type: "array" });
 
         workbook.SheetNames.forEach(function (sheetName) {
           // Here is your object
           var XL_row_object = XLSX.utils.sheet_to_json(
             workbook.Sheets[sheetName]
           );
           hojas.push({
             data: XL_row_object,
             sheetName,
           });
         });
 
         let A1 = hojas[0].data
 
         let TC = totalCaptura
         A1.map((a)=>{
            TC = TC + 1
           setTotalCaptura(TC)
         inputFields.push({
           id: uuidv4(),
           articulos: a.IdArticulo,
          cantidad: a.diferencia,
          cantInv: 0,
          idInv: a.IdInv
         })
         })
 
         ActualizaTotales()
       }
   }
 }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ajustesInventario ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Ajuste De Inventario</h3>
          <Form onSubmit={saveAjustesInventario}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>

              <Col md={3}>
                <Label className="mr-sm-2">Almacen</Label>
                {user.areas == AREAS_GENERAL ? (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedArea}
                    required
                    onChange={(e) => {
                      jalaAlmacen(e.target.value);
                    }}
                  >
                    <option value="0">Almacen</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id != AREAS_GENERAL) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                ) : (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedArea}
                    required
                    onChange={(e) => {
                      jalaAlmacen(e.target.value);
                    }}
                  >
                    <option value="0">Almacen</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas == a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                )}
              </Col>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            
          {/* <Row>
            <Col md={3}>
            <Label>Selecciona</Label>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
            </Row>  */}

            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Codigo QR</Label>
              </Col>
              <Col md={6}>
                <Label className="mr-sm-2">Modelo</Label>
              </Col>
              {/* {selectedArea == AREAS_CEDIS ? ( */}
                <Col md={1}>
                  <Label className="mr-sm-2">Ubicacion</Label>
                </Col>
              {/* ) : undefined} */}

              <Col md={1}>
                <Label className="mr-sm-2">Inventario</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="string"
                      value={inputField.articulos}
                      onChange={(event) => {
                        BuscaCodigo(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={6}>
                  <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.SKU} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </Col>
                  {/* {selectedArea == AREAS_CEDIS ? ( */}
                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="ubicacion"
                        type="select"
                        value={inputField.idInv}
                        required
                        onChange={(event) => {
                          BuscaUbicacion(inputField.id, event.target.value);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {inventarios
                          .sort((a, b) => (a.ubicacion > b.ubicacion ? 1 : -1))
                          .map((a) => {
                            if (a.idArticulo == inputField.articulos) {
                              return (
                                <option value={a._id}>{a.ubicacion}</option>
                              );
                            }
                          })}
                      </Input>
                    </Col>
                  {/* ) : undefined} */}

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantInv"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantInv}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoAjustesInventario"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default AjustesInventarioCreate;
